import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'devportal-org-hub',
});

export const showGroupRouteRef = createSubRouteRef({
  id: 'devportal-org-hub/group',
  path: '/groups/:id',
  parent: rootRouteRef,
});

export const editGroupRouteRef = createSubRouteRef({
  id: 'devportal-org-hub/group',
  path: '/groups/:id/edit',
  parent: rootRouteRef,
});
